import * as React from 'react';
import { BulkExportContextReact, BulkExportServiceContextReact } from '../BulkExportContextReact';
import { BulkExportContext } from '../BulkExportContext';
import { BulkExportService } from '../services/BulkExportService2';

export function useBulkExportAPI() : [BulkExportContext, BulkExportService | undefined]{
  const context = React.useContext(BulkExportContextReact);
  const service = React.useContext(BulkExportServiceContextReact);

  return [context, service];
}